export default "__VITE_ASSET__BwIr937m__"